import { Asset } from "../../interfaces/asset";
import { METAL_TYPE } from "@helpers/constants";

export class Metal extends Asset {
	protected static readonly currencyType: string = METAL_TYPE;

	public getCurrencyType(): string {
		return Metal.currencyType;
	}

	private measurement_unit: string = "";

	public getSymbol(lc: boolean = false, name: boolean = false): string {
		if (lc) {
			return this.symbol.toLocaleLowerCase();
		}

		if (name) {
			return this.name;
		}
		return this.measurement_unit;
	}

	public getPrecision(): number {
		return this.precision_for_coins;
	}

	// Todo probably its always true, as no withdraw/deposit will be allowed
	public isHodlTradable(type: string = ""): boolean {
		return false;
	}
}
